<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormRole
          :data="role"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          @submit="roleSubmitHandle"
          @cancel="$router.push({ name: 'page-roles' })"
          @delete-role="deleteRole"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmRoleRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import FormRole from '@/pages/role/form/FormRole.vue'
import roleQuery from '@/services/gql/types/Roles/queries/role.gql'
import updateRoleMutation from '@/services/gql/types/Roles/mutations/updateRole.gql'
import createRoleMutation from '@/services/gql/types/Roles/mutations/createRole.gql'
import deleteRoleMutation from '@/services/gql/types/Roles/mutations/deleteRole.gql'

export default {
  name: 'PageRole',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    FormRole,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать роль' : 'Создать роль'
    }
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.role.loading
    },
    isMutationLoading () {
      return this.$async.createRole.$pending ||
        this.$async.updateRole.$pending
    }
  },
  data () {
    return {
      role: {}
    }
  },
  methods: {
    async deleteRole () {
      try {
        await this.$refs.confirmRoleRemoving.open()
        await this.$async.deleteRole.$perform({ id: this.id })
        this.$successMsg('Роль удалена')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении роли с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-roles' })
      }
    },
    roleSubmitHandle (data) {
      if (this.id) this.updateRole(data)
      else this.createRole(data)
    },
    async createRole (data) {
      try {
        await this.$async.createRole.$perform({ data })
        this.$successMsg('Роль создана')
        this.$emit('updated')
        await this.$router.push({ name: 'page-roles' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании роли')
      }
    },
    async updateRole (data) {
      try {
        await this.$async.updateRole.$perform({
          id: Number(this.id),
          data
        })
        this.$successMsg('Роль обновлена')
        this.$emit('updated')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'role.update')
      }
    }
  },
  apollo: {
    role: {
      fetchPolicy: 'network-only',
      query: roleQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-roles' })
        }
        this.role = res?.data?.role
      }
    }
  },
  async: {
    deleteRole (variables) {
      return this.$apollo.mutate({
        mutation: deleteRoleMutation,
        variables
      })
    },
    createRole (variables) {
      return this.$apollo.mutate({
        mutation: createRoleMutation,
        variables
      })
    },
    updateRole (variables) {
      return this.$apollo.mutate({
        mutation: updateRoleMutation,
        variables
      })
    }
  }
}
</script>
